"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const caretback = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-caretback` : '') + (description ? ` desc-caretback` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-caretback"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-caretback"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.1879 1.0278L6.70864 10.8545L6.61231 10.9641C6.37537 11.2631 6.25 11.6257 6.25 12C6.25 12.4293 6.41485 12.8414 6.7091 13.146L16.1879 22.9722L16.2755 23.0515C16.6528 23.3425 17.164 23.3057 17.4857 22.9722L17.5664 22.8765C17.8357 22.5103 17.8087 21.9877 17.4857 21.6528L8.173 12L17.4857 2.34721L17.5621 2.25651C17.8376 1.87266 17.8031 1.3568 17.4857 1.0278C17.1284 0.657401 16.5452 0.657401 16.1879 1.0278Z",
    fill: "inherit"
  }));
};
var _default = exports.default = caretback;